import BlueWhaleResearchLoaderLogo from "@/assets/logo/bluewhaleresearch-loaderlogo.png";
import BlueWhaleResearchLogo from "@/assets/logo/bluewhaleresearch-logo.png";
import BlueWhaleResearchMiniLogo from "@/assets/logo/bluewhaleresearch-miniLogo.png";
import ContanuityLogo from "@/assets/logo/contanuity-logo.png";
import ContanuityMiniLogo from "@/assets/logo/contanuity-miniLogo.png";
import DemandScienceLogo from "@/assets/logo/demandscience-logo.png";
import DemandScienceMiniLogo from "@/assets/logo/demandscience-miniLogo.png";
import DemandViewIcon from "@/assets/logo/demandview-icon.svg";
import DemandViewLogoBlack from "@/assets/logo/demandview-logo-black.svg";
import DemandViewLogo from "@/assets/logo/demandview-logo.svg";
import FounderVideoLogo from "@/assets/logo/foundervideo-logo.png";
import FounderVideoMiniLogo from "@/assets/logo/foundervideo-miniLogo.svg";
import ImaginariumLogo from "@/assets/logo/imaginarium-logo.svg";
import ImaginariumMiniLogo from "@/assets/logo/imaginarium-miniLogo.png";
import IntentsifyLogo from "@/assets/logo/Intentsify-logo.png";
import IntentsifyMiniLogo from "@/assets/logo/Intentsify-miniLogo.png";
import LeadspaceIcon from "@/assets/logo/leadspace-icon.png";
import LeadspaceLogoBlack from "@/assets/logo/leadspace-logo-black.png";
import LeadspaceLogoWhite from "@/assets/logo/leadspace-logo-white.png";
import Octane11BlackLogo from "@/assets/logo/octane11-logo-black.png";
import Octane11Logo from "@/assets/logo/octane11-logo.svg";
import Octane11MiniLogo from "@/assets/logo/octane11-miniLogo.png";
import ProspectBaseIcon from "@/assets/logo/prospectbase-icon-white.svg";
import ProspectBaseLogoBlack from "@/assets/logo/prospectbase-logo-black.svg";
import ProspectBaseLogoWhite from "@/assets/logo/prospectbase-logo-white.svg";

const config = {
  CONTANUITY: {
    theme: "tertiary",
    brand: {
      logo: ContanuityLogo,
      miniLogo: ContanuityMiniLogo,
      loaderLogo: null,
      name: "Contanuity",
      title: "Contanuity",
      favFolderName: "contanuity",
    },
    pixel: {
      url: "https://tracking.contanuity.com",
      identifierName: "CONTANUITY_TAG",
      tagPath: "/tag.js",
    },
    billing: true,
  },
  DEMANDSCIENCE: {
    theme: "default",
    brand: {
      logo: DemandScienceLogo,
      miniLogo: DemandScienceMiniLogo,
      loaderLogo: null,
      name: "Demand Science",
      title: "ABM Display by DemandScience",
      favFolderName: "demand-science",
    },
    pixel: {
      url: "https://abm-tracking.demandscience.com",
      identifierName: "TAG_INFO",
      tagPath: "/tag.js",
    },
    billing: false,
  },
  INTENTSIFY: {
    theme: "tertiary",
    brand: {
      logo: IntentsifyLogo,
      miniLogo: IntentsifyMiniLogo,
      loaderLogo: null,
      name: "Intentsify",
      title: "Intentsify",
      favFolderName: "intentsify",
    },
    pixel: {
      url: "https://tracking.contanuity.com",
      identifierName: "CONTANUITY_TAG",
      tagPath: "/tag.js",
    },
    billing: false,
  },
  BLUEWHALERESEARCH: {
    theme: "tertiary",
    brand: {
      logo: BlueWhaleResearchLogo,
      miniLogo: BlueWhaleResearchMiniLogo,
      loaderLogo: BlueWhaleResearchLoaderLogo,
      name: "BlueWhale Research",
      title: "BlueWhale Research",
      favFolderName: "bluewhale-research",
    },
    pixel: {
      url: "https://signal.bluewhaleresearch.com",
      identifierName: "BWR_TAG",
      tagPath: "/u01AegDdnh/tag.js",
    },
    billing: false,
  },
  PROSPECTBASE: {
    theme: "tertiary",
    brand: {
      logo: ProspectBaseLogoWhite,
      miniLogo: ProspectBaseIcon,
      loaderLogo: ProspectBaseLogoBlack,
      name: "Prospect Base",
      title: "Prospect Base",
      favFolderName: "prospect-base",
    },
    pixel: {
      url: "https://tracking.prospectbase.com",
      identifierName: "PB_TAG",
      tagPath: "/qCz7yH0dYI/tag.js",
    },
    billing: false,
  },
  LEADSPACE: {
    theme: "tertiary",
    brand: {
      logo: LeadspaceLogoWhite,
      miniLogo: LeadspaceIcon,
      loaderLogo: LeadspaceLogoBlack,
      name: "Leadspace",
      title: "Leadspace",
      favFolderName: "leadspace",
    },
    pixel: {
      url: "https://radar.leadspace.com",
      identifierName: "LS_TAG",
      tagPath: "/m2vR10uCZP/tag.js",
    },
    billing: false,
  },
  IMAGINARIUM: {
    theme: "tertiary",
    brand: {
      logo: ImaginariumLogo,
      miniLogo: ImaginariumMiniLogo,
      loaderLogo: null,
      name: "Imaginarium",
      title: "Imaginarium",
      favFolderName: "imaginarium",
    },
    pixel: {
      url: "https://tracking.contanuity.com",
      identifierName: "CONTANUITY_TAG",
      tagPath: "/tag.js",
    },
    billing: false,
  },
  OCTANE11: {
    theme: "tertiary",
    brand: {
      logo: Octane11Logo,
      miniLogo: Octane11MiniLogo,
      loaderLogo: Octane11BlackLogo,
      name: "Octane11",
      title: "Octane11",
      favFolderName: "octane11",
    },
    pixel: {
      url: "https://tracking.contanuity.com",
      identifierName: "CONTANUITY_TAG",
      tagPath: "/tag.js",
    },
    billing: false,
  },
  FOUNDERVIDEO: {
    theme: "tertiary",
    brand: {
      logo: FounderVideoLogo,
      miniLogo: FounderVideoMiniLogo,
      loaderLogo: null,
      name: "FounderVideo",
      title: "FounderVideo",
      favFolderName: "founder-video",
    },
    pixel: {
      url: "https://tracking.foundervideo.com",
      identifierName: "FV_TAG",
      tagPath: "/H0y3QIifrc/tag.js",
    },
    billing: false,
  },
  DEMANDVIEW: {
    theme: "tertiary",
    brand: {
      logo: DemandViewLogo,
      miniLogo: DemandViewIcon,
      loaderLogo: DemandViewLogoBlack,
      name: "DemandView",
      title: "DemandView",
      favFolderName: "demandview",
    },
    pixel: {
      url: "https://siteview.demandview.ai",
      identifierName: "DV_TAG",
      tagPath: "/0JohCxgxZU/tag.js",
    },
    billing: false,
  },
};

export default config;
